import { SpriteState } from '@amcharts/amcharts4/core';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createExportUserGdprReportAction, IExportUserGdprReportAction } from '../actions/ProfileActions';
import { ICanExportGdprReportState } from '../reducers/ProfileReducers';
import { IState } from '../state/State';

export interface IGdprExportBodyProps {
    canGdprExport: ICanExportGdprReportState,
    exportUserGdprReport: () => IExportUserGdprReportAction;
  }

  const handleExportGdprReportButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, props: IGdprExportBodyProps) => {
    props.exportUserGdprReport();
  }

const GdprExportBody: React.FC<IGdprExportBodyProps> = (props: IGdprExportBodyProps) => {
    let exportDataView;
    let currentDate = new Date();
    let allowedRequestDate = props?.canGdprExport?.result?.requestTime != null ? new Date(props.canGdprExport.result.requestTime) : new Date(9000, 0, 1);

    let [state, setState] = useState({linkClicked: false});
    if (props?.canGdprExport?.result?.requestTime == null) {
        exportDataView = "(loading...)"
    }
    else if (state.linkClicked) {
        exportDataView = <p className="GdprExportRequestSentText">Your export request was sent to the server. You should receive an e-mail to your login e-mail address shortly with a link to download your report.</p>
    }
    else if (currentDate > allowedRequestDate) {
      exportDataView = <button onClick={e => { handleExportGdprReportButtonClick(e, props); setState({linkClicked: true});} }>Click here to request your personalized data report</button>
    }
    else {
        let options: Intl.DateTimeFormatOptions = {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
        }

        exportDataView = <em>You've requested a data export recently. The next time you can request an export is after <span className="GdprNextRequestText">{allowedRequestDate.toLocaleString(undefined, options)}</span>.</em>
    }

    return (
      <div className="GdprExportBody">
        <p>LAMA LLC collects and stores personal and behaviorial data about you to provide you features and services in our game, Rhythm Horizon, as well as via this website. If you would like a report of all the data we store about you and why we store it, click the link below to request a report.</p>
        <br />
        <p>Note that you can only request this report once per day.</p>
        <br />
        {exportDataView}
      </div>
    );
  }

  const mapStateToProps = (state: IState) => ({
    canGdprExport: state.canGdprExport,
  });

  const actionCreators = {
    exportUserGdprReport: createExportUserGdprReportAction,
  }
  
  export default connect(mapStateToProps, actionCreators)(GdprExportBody);